// extracted by mini-css-extract-plugin
export default {"mainContainer":"mainContainer___ytd4e","wasteAccompanyingDocumentContainer":"wasteAccompanyingDocumentContainer___NW6vB"};